import { render, staticRenderFns } from "./D4.vue?vue&type=template&id=0528725d&scoped=true&"
import script from "./D4.vue?vue&type=script&lang=ts&"
export * from "./D4.vue?vue&type=script&lang=ts&"
import style0 from "./D4.vue?vue&type=style&index=0&id=0528725d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0528725d",
  null
  
)

export default component.exports